import type { AppRouteRecordRaw } from '@/router/types';
import { useI18n } from '@/hooks/web/useI18n';
import { LAYOUT, BLANK } from '@/router/constant';

const { t } = useI18n();

const SysSetting_ROUTES: AppRouteRecordRaw[] = [
  {
    path: '/system-settings',
    name: 'sysSetting',
    component: LAYOUT,
    meta: {
      title: t('router.systemSetting'),
      hideBreadcrumb: true,
      hideMenu: false,
      icon: 'setting',
      perCode: import.meta.env.MODE === 'web' ? 'kedex:system:settings' : 'SYSTEM_SETTINGS'
    },
    children: [
      {
        path: 'site-configuration',
        name: 'projectBasicConfiguration',
        component: BLANK,
        redirect: '/system-settings/site-configuration/index',
        meta: {
          title: t('router.projectInfoConfiguration'),
          transition: 'out-in',
          master: true,
          perCode:
            import.meta.env.MODE === 'web'
              ? 'kedex:system:settings:basic:configuration'
              : 'kedex:basic:configuration'
        },
        children: [
          {
            path: 'index',
            name: 'projectBasicConfigurationList',
            component: () => import('@/views/buildingElevator/projectBasicConfig.vue'),
            meta: {
              title: t('buildingElevator.buildingElevatorConfiguration'),
              transition: 'out-in',
              layout: 'adaptive-height'
            }
          },
          {
            path: 'create-building-elevator',
            name: 'createBuildingElevator',
            component: () =>
              import('@/views/buildingElevator/residential-building/create-building-elevator.vue'),
            meta: {
              title: t('buildingElevator.createBuildingElevator'),
              hideMenu: true,
              transition: 'out-in',
              layout: 'detail-adaptive-height'
            }
          },
          {
            path: 'create-online-building',
            name: 'createOnlineBuilding',
            component: () =>
              import('@/views/buildingElevator/residential-building/create-online-building.vue'),
            meta: {
              title: t('buildingElevator.createBuildingElevator'),
              transition: 'out-in',
              hideMenu: true,
              layout: 'detail-adaptive-height'
            }
          },
          {
            path: 'create-success',
            name: 'success',
            component: () => import('@/views/buildingElevator/residential-building/success.vue'),
            meta: {
              title: t('buildingElevator.createBuildingElevator'),
              hideMenu: true,
              layout: 'detail-adaptive-height'
            }
          },
          {
            path: 'improve-room',
            name: 'improveRoom',
            component: () =>
              import('@/views/buildingElevator/residential-building/improve-room.vue'),
            meta: {
              title: t('buildingElevator.editBuildingInfo'),
              hideMenu: true,
              layout: 'detail-adaptive-height'
            }
          },
          {
            path: 'check-building-info',
            name: 'checkBuildingInfo',
            component: () =>
              import('@/views/buildingElevator/residential-building/check-building-info.vue'),
            meta: {
              title: t('buildingElevator.checkBuildingInfo'),
              hideMenu: true,
              layout: 'empty'
            }
          },
          {
            path: 'check-building-info-online',
            name: 'checkBuildingInfoOnline',
            component: () =>
              import('@/views/buildingElevator/residential-building/check-building-info-online.vue'),
            meta: {
              title: t('buildingElevator.checkBuildingInfo'),
              hideMenu: true,
              layout: 'empty'
            }
          },
          {
            path: 'edit-building-info',
            name: 'editBuildingInfo',
            component: () =>
              import('@/views/buildingElevator/residential-building/edit-building-info.vue'),
            meta: {
              title: t('buildingElevator.editBuildingInfo'),
              hideMenu: true,
              layout: 'detail-adaptive-height'
            }
          },
          {
            path: 'general-building-editor',
            name: 'generalBuildingEditor',
            component: () =>
              import('@/views/buildingElevator/general-elevators/general-building-editor.vue'),
            meta: {
              title: t('buildingElevator.editBuildingInfo'),
              transition: 'out-in',
              hideMenu: true,
              layout: 'detail-adaptive-height'
            }
          },
          {
            path: 'online-general-building',
            name: 'onlineGeneralBuilding',
            component: () =>
              import('@/views/buildingElevator/general-elevators/online-general-building.vue'),
            meta: {
              title: t('buildingElevator.createGeneralElevator'),
              transition: 'out-in',
              hideMenu: true,
              layout: 'detail-adaptive-height'
            }
          },
          {
            path: 'general-create-elevator',
            name: 'generalCreateElevator',
            component: () =>
              import('@/views/buildingElevator/general-elevators/general-create-elevator.vue'),
            meta: {
              title: t('buildingElevator.createGeneralElevator'),
              transition: 'out-in',
              hideMenu: true,
              layout: 'detail-adaptive-height'
            }
          },
          {
            path: 'general-create-success',
            name: 'generalCreateSuccess',
            component: () =>
              import('@/views/buildingElevator/general-elevators/general-create-success.vue'),
            meta: {
              title: t('buildingElevator.createGeneralElevator'),
              transition: 'out-in',
              hideMenu: true,
              layout: 'detail-adaptive-height'
            }
          },
          {
            path: 'edit-general-info',
            name: 'editGeneralInfo',
            component: () =>
              import('@/views/buildingElevator/general-elevators/edit-general-info.vue'),
            meta: {
              title: t('buildingElevator.editBuildingInfo'),
              transition: 'out-in',
              hideMenu: true
            }
          },
          {
            path: 'online-edit-info',
            name: 'editGeneralInfoOnline',
            component: () =>
              import('@/views/buildingElevator/general-elevators/online-edit-info.vue'),
            meta: {
              title: t('buildingElevator.editBuildingInfo'),
              transition: 'out-in',
              hideMenu: true,
              layout: 'detail-adaptive-height'
            }
          },
          {
            path: 'check-general-info',
            name: 'checkGeneralInfo',
            component: () =>
              import('@/views/buildingElevator/general-elevators/check-general-info.vue'),
            meta: {
              title: t('buildingElevator.checkBuildingInfo'),
              transition: 'out-in',
              hideMenu: true,
              layout: 'empty'
            }
          },
          {
            path: 'check-general-info-online',
            name: 'checkGeneralInfoOnline',
            component: () =>
              import('@/views/buildingElevator/general-elevators/check-general-info-online.vue'),
            meta: {
              title: t('buildingElevator.checkBuildingInfo'),
              transition: 'out-in',
              hideMenu: true,
              layout: 'empty'
            }
          }
        ]
      },
      {
        path: 'dataSynchronous',
        name: 'dataSynchronous',
        component: BLANK,
        redirect: '/system-settings/dataSynchronous/index',
        meta: {
          title: t('router.dataAndSystemLogs'),
          master: true,
          hideBreadcrumb: true,
          hideMenu: false,
          perCode:
            import.meta.env.MODE === 'web'
              ? 'kedex:system:settings:data:logs'
              : 'DATA_AND_SYSTEM_LOGS'
        },
        children: [
          {
            path: 'index',
            name: 'dataSynchronousIndex',
            // 数据备份&还原
            component: () => import('@/views/dataSynchronous/dataSync.vue'),
            meta: {
              title: t('router.dataAndSystemLogs')
            }
          }
        ]
      },
      // {
      //   path: 'account-management',
      //   name: 'AccountManagement',
      //   component: BLANK,
      //   redirect: '/system-settings/account-management/index',
      //   meta: {
      //     title: t('router.accountManagement'),
      //     transition: 'out-in',
      //     master: true,
      //     perCode:
      //       import.meta.env.MODE === 'web'
      //         ? 'kedex:system:settings:account:management'
      //         : 'AccountManagement'
      //   },
      //   children: [
      //     {
      //       path: 'index',
      //       name: 'accountManagementIndex',
      //       //账号管理
      //       component: () => import('@/views/userManagement/userMgrList.vue'),
      //       meta: {
      //         title: t('router.accountManagement')
      //       }
      //     },
      //     {
      //       path: 'addOrEditRole',
      //       name: 'AddOrEditRole',
      //       component: () => import('@/views/userManagement/addOrEditRole.vue'),
      //       meta: {
      //         title: t('userManagement.addRole'),
      //         hideBreadcrumb: true,
      //         hideMenu: true
      //       }
      //     },
      //     {
      //       path: 'edit',
      //       name: 'AddOrEditUer',
      //       component: () => import('@/views/userManagement/addOrEditUser.vue'),
      //       meta: {
      //         title: t('userManagement.userInfo'),
      //         hideBreadcrumb: true,
      //         hideMenu: true
      //       }
      //     },
      //     {
      //       path: '/updateSelfPwd',
      //       name: 'UpdateSelfPwd',
      //       component: () => import('@/views/userManagement/updateSelfPwd.vue'),
      //       meta: {
      //         title: t('userManagement.userInfo'),
      //         hideBreadcrumb: true,
      //         hideMenu: true
      //       }
      //     }
      //   ]
      // },
      // {
      //   path: 'remote-account-manager',
      //   name: 'remoteAccountManager',
      //   component: BLANK,
      //   redirect: '/system-settings/remote-account-manager/index',
      //   meta: {
      //     title: t('router.subAccountManagement'),
      //     transition: 'out-in',
      //     master: true,
      //     perCode: 'KONE_ONLINE_JUNIOR_ACCOUNT'
      //   },
      //   children: [
      //     {
      //       path: 'index',
      //       name: 'subAccountManagementIndex',
      //       //子账号管理
      //       component: () => import('@/layouts/microApp/index.vue'),
      //       meta: {
      //         title: t('router.subAccountManagement'),
      //         microUrl: '/kol/index.html#/kol/subAccount',
      //         path: '/#/kol/subAccount'
      //       }
      //     }
      //   ]
      // }
      {
        path: 'account-magement',
        name: 'account-magement',
        component: () => import('@/views/amp2/accountMangement.vue'),
        meta: {
          title: t('router.accountManagement'),
          hideBreadcrumb: false,
          hideMenu: false,
          master: true,
          layout: 'empty',
          perCode: 'kedex:amp2:accountMangement'
        }
      },
      {
        path: 'template-residual-life',
        name: 'template-residual-life',
        component: () => import('@/views/amp2/templateResidualLife.vue'),
        meta: {
          title: t('router.templateResidualLife'),
          hideBreadcrumb: false,
          hideMenu: false,
          master: true,
          layout: 'empty',
          perCode: 'kedex:amp2:systemSetting2:templateResidualLIfe'
        }
      },
      {
        path: 'project-residual-life',
        name: 'project-residual-life',
        component: () => import('@/views/amp2/projectResidualLife.vue'),
        meta: {
          title: t('router.projectResidualLife'),
          hideBreadcrumb: false,
          hideMenu: false,
          master: true,
          layout: 'empty',
          perCode: 'kedex:amp2:systemSetting2:projectResidualLife'
        }
      }
    ]
  }
];

export default SysSetting_ROUTES;
